import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import './Tooltip.scss';

const Tooltip = ({
  content,
  children,
  placement = 'top',
  interactive = false,
  arrow = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipId = useId();

  const show = () => setIsOpen(true);
  const hide = () => setIsOpen(false);

  return (
    <span
      className="tooltip"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      onKeyDown={(event) => {
        if (event.key === 'Escape') hide();
      }}
      aria-describedby={isOpen ? tooltipId : undefined}
    >
      {children}

      {isOpen && (
        <span
          id={tooltipId}
          role="tooltip"
          className={`tooltip__bubble tooltip__bubble--${placement}`}
          onMouseEnter={interactive ? show : undefined}
          onMouseLeave={interactive ? hide : undefined}
        >
          {content}
          {arrow && <span className="tooltip__arrow" aria-hidden="true" />}
        </span>
      )}
    </span>
  );
};

Tooltip.propTypes = {
  content: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  interactive: PropTypes.bool,
  arrow: PropTypes.bool,
};

export default Tooltip;
